import { cloudTransport } from "../../../services/cloud";
import {
  FirestoreAuditRepository,
  FirestoreOrganizationRepository,
  FirestoreTankRepository,
  FirestoreTripCargoRepository,
  FirestoreTripRepository,
  FirestoreVesselParticularsRepository,
  FirestoreVesselRepository,
  FirestoreVoyageRepository,
} from "./repositories";

export const createFirestoreRemoteDataAccess = (
  db = cloudTransport.getAuthenticatedInstallation().db
) => ({
  db,
  repositories: {
    organizations: new FirestoreOrganizationRepository(db),
    vessels: new FirestoreVesselRepository(db),
    vesselParticulars: new FirestoreVesselParticularsRepository(db),
    tanks: new FirestoreTankRepository(db),
    voyages: new FirestoreVoyageRepository(db),
    trips: new FirestoreTripRepository(db),
    tripCargo: new FirestoreTripCargoRepository(db),
    auditEntries: new FirestoreAuditRepository(db),
  },
});
